import { StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { BpM } from '../shared/brakepoints';
import Translator from './Translator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt, faEnvelope, faHeadset, faPhone } from '@fortawesome/free-solid-svg-icons';
import cx from 'classnames';
import { callbackServiceUrl, supportChatUrl } from '../shared/api/urls';
import FintechOneAddress from './FintechOneAddress';

type CssClasses = 'fullPage' | 'contactP' | 'fntBig' | 'contactTable';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  fullPage: {
    height: '100%',
  },
  contactP: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  fntBig: {
    fontSize: '15px !important',
    fontWeight: 700,
  },
  contactTable: {
    fontSize: '17px',
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    color: '#666',
    display: 'flex',
    width: '250px',
    flexFlow: 'row wrap',
    [BpM()]: {
      marginLeft: '20px',
    },
    marginTop: '20px',
    alignItems: 'center',
    '& > svg': {
      flex: '0 0 50px',
      marginRight: '10px',
    },
    '& > p': {
      flex: '0 0 180px',
    },
  },
});

interface OwnProps {
  withRequest?: boolean;
}

class FintechOneSupport extends React.Component<OwnProps & WithStyles<CssClasses>> {
  render() {
    let { classes, withRequest } = this.props;
    return (
      <Translator>
        {translate => {
          return (
            <div>
              {withRequest && translate('errorPleaseContact')}
              <div className={classes.contactTable}>
                <FontAwesomeIcon icon={faPhone} color={'#E2001A'} size={'2x'} />
                <p className={cx(classes.contactP)}>
                  {translate('contactCustomerService')}
                  <br />
                  <b>{translate('contactSupportNumber')}</b>
                </p>

                <FontAwesomeIcon icon={faHeadset} color={'#E2001A'} size={'lg'} />
                <p className={cx(classes.contactP, classes.fntBig)}>
                  <a href={callbackServiceUrl}>{translate('contactCallbackService')}</a>
                </p>
                <FontAwesomeIcon icon={faCommentAlt} color={'#E2001A'} size={'lg'} />
                <p className={cx(classes.contactP, classes.fntBig)}>
                  <a onClick={this.handleChat} style={{ textDecoration: 'underline' }}>
                    {translate('contactSupportChat')}
                  </a>
                </p>
                <FontAwesomeIcon icon={faEnvelope} color={'#E2001A'} size={'lg'} />
                <p className={cx(classes.contactP, classes.fntBig)}>{translate('contactMailAddress')}</p>
              </div>
              <FintechOneAddress />
            </div>
          );
        }}
      </Translator>
    );
  }

  public handleChat = () => {
    window.open(
      supportChatUrl,
      '',
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,' +
        'resizable=0,width=510,height=560,left = 1355,top =560'
    );
  };
}

export default pure(withStyles(styles)(FintechOneSupport));



// WEBPACK FOOTER //
// ./src/components/FintechOneSupport.tsx